import { render, staticRenderFns } from "./RuleFormGroup.vue?vue&type=template&id=66dfbb6b"
import script from "./RuleFormGroup.vue?vue&type=script&lang=js"
export * from "./RuleFormGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports